/** Espejo de `SupportActionType` en backend-v2 (KB-903). */
export enum SupportActionType {
  ENROLLMENT_WITHDRAW = 'ENROLLMENT_WITHDRAW',
  ENROLLMENT_CHANGE_COURSE = 'ENROLLMENT_CHANGE_COURSE',
  ENROLLMENT_CHANGE_CAMPUS = 'ENROLLMENT_CHANGE_CAMPUS',
  STUDENT_FIX_PERSONAL_DATA = 'STUDENT_FIX_PERSONAL_DATA',
  STUDENT_FIX_EMAIL = 'STUDENT_FIX_EMAIL',
  PARENT_FIX_EMAIL = 'PARENT_FIX_EMAIL',
  STUDENT_FIX_DNI = 'STUDENT_FIX_DNI',
  TEACHER_CREATE = 'TEACHER_CREATE',
  TEACHER_REASSIGN_COURSE = 'TEACHER_REASSIGN_COURSE',
  SIBLINGS_CROSSED_RECORDS = 'SIBLINGS_CROSSED_RECORDS',
  LICENSE_GRANT = 'LICENSE_GRANT',
  USER_COMPLETE_AFTER_REDEMPTION = 'USER_COMPLETE_AFTER_REDEMPTION',
  PASSWORD_RESET_TRIGGER = 'PASSWORD_RESET_TRIGGER',
  ACCESS_DIAGNOSE = 'ACCESS_DIAGNOSE',
  REQUEST_MORE_INFO = 'REQUEST_MORE_INFO',
  CLASSIFY_AND_ROUTE = 'CLASSIFY_AND_ROUTE',
  CLOSE_AS_NOISE = 'CLOSE_AS_NOISE',
}

/** Espejo de `SupportRequestLane` en backend-v2 (KB-907). */
export enum SupportRequestLane {
  READY_TO_APPROVE = 'READY_TO_APPROVE',
  NEEDS_DECISION = 'NEEDS_DECISION',
  MANUAL = 'MANUAL',
}

/**
 * Campos que puede traer `ActionListItem.changes` (KB-907). Espejo de
 * `ChangeField` en backend-v2 — cada gestión propone cambiar 0+ de estos.
 */
export const CHANGE_FIELDS = [
  'course',
  'campus',
  'school',
  'studentEmail',
  'parentEmail',
  'firstName',
  'lastName',
  'lastName2nd',
  'birthDate',
  'dni',
  'teacherCourses',
] as const;

export type ChangeField = typeof CHANGE_FIELDS[number];
